// Class strings shared by the Marketing page, its drawers and dialogs.

export const buttonClass = {
  primary:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] bg-indigo-600 px-[18px] text-sm font-semibold text-white hover:bg-indigo-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-indigo-300",
  secondary:
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px] border border-gray-300 bg-white px-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
  dangerOutline:
    "inline-flex min-h-10 items-center justify-center gap-1.5 rounded-lg border border-red-200 bg-white px-3.5 text-sm font-semibold text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50",
  small:
    "inline-flex min-h-9 items-center justify-center rounded-lg border border-gray-300 bg-white px-3 text-[13px] font-semibold text-gray-900 hover:bg-gray-50",
};

export const inputClass =
  "block min-h-11 w-full rounded-[10px] border border-gray-300 px-3 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-indigo-500";

export const labelClass = "text-[13px] font-semibold text-gray-700";

// Rounded chip, indigo when on.
export function chipClass(on) {
  return `inline-flex min-h-9 items-center gap-1.5 rounded-full border px-3 text-[13px] font-medium whitespace-nowrap ${
    on
      ? "border-indigo-600 bg-indigo-50 text-indigo-800"
      : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
  }`;
}
